module.exports = __webpack_public_path__ + "f5ed12d168ba830087c6c2484ba7f761.pdf";